export default __webpack_public_path__ + "static/assets/35d81c0b48cd9393fd7c6988ea701ad5.png";